/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import api, { reportApiError } from '../api'
import get from 'lodash/get'

const qs = require('qs')

export default {
  state: {
    timezones: [],
	},
	getters: {
    getTimezones(state) {
      return state.timezones
    }
	},
	mutations: {
    ADD_TIMEZONES(state, timezones) {
      state.timezones = timezones
    }
  },
  actions: {
    LOAD_TIMEZONES({ commit }) {
      return api.post(`${process.env.VUE_APP_API_URL}/get_timezone_from_file`)
        .then(
          (response) => {
            const zones = get(response, 'data.data.windowsZones.mapTimezones.mapZone', [])
            commit('ADD_TIMEZONES', zones)
        }
      )
        .catch((error) => {
          reportApiError(error, 'get_timezone_from_file')
          commit('ADD_TIMEZONES', [])
        })
    }
  }
}
